import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type FeatureFlagsService from 'garaje/services/feature-flags';

// export type LocationOverviewVirtualFrontDeskCallLogModel = {};

export default class LocationOverviewVirtualFrontDeskCallLogRoute extends Route {
  @service declare featureFlags: FeatureFlagsService;
  @service declare router: RouterService;

  beforeModel(): void {
    if (!this.featureFlags.isEnabled('visitors-vfd-call-log')) {
      // feature flag not enabled - redirect to base VFD route
      void this.router.transitionTo('location-overview.virtual-front-desk');
    }
  }
}
